import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColorTypeEnum } from '@shared/enums/color-type.enum';

/**
 * Progress bar component show scale filled by percent value
 */
@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProgressBarComponent implements OnChanges {
  // progress bar value
  @Input() value: number;
  // @TODO TT-4522 if not provided should depends on the value (like >90% green, >80% blue, >60% yellow, >0% red)
  @Input() color: ColorTypeEnum;
  @Input() colorClass: string;
  // total value (100%) for percent calculation
  @Input() total: number;
  @Input() label: string;
  @Input() type: 'currency' | 'percent' = 'currency';
  @Input() size?: 'lg';
  percent: number;
  colorTypeEnum = ColorTypeEnum;

  ngOnChanges(changes: SimpleChanges): void {
    // check @Input values and handle progress bar fill logic
    if (changes.value) {
      switch (true) {
        case this.total === 0 && !!this.value:
          this.percent = 100;
          break;
        case !this.total && !this.value:
          this.percent = 0;
          break;
        default:
          this.percent = Math.abs(this.value) / Math.abs(this.total) * 100;
      }
    }
  }
}
